import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { Schema, ValidationError } from 'yup-legacy';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { ValidationResolver } from 'react-hook-form-legacy';

const useYupValidationResolver = (
  validationSchema: Schema<any>,
  context?: object,
): ValidationResolver<any, any> =>
  useCallback(
    (data) =>
      validationSchema
        .validate(data, {
          abortEarly: false,
          context,
        })
        .then((values) => ({ values, errors: {} }))
        .catch((errors: ValidationError) => ({
          values: {},
          errors:
            errors.inner?.reduce(
              (allErrors, currentError) => ({
                ...allErrors,
                [currentError.path]: {
                  type: currentError.type ?? 'validation',
                  message: currentError.message,
                },
              }),
              {},
            ) ?? {},
        })),
    [validationSchema, context],
  );
export default useYupValidationResolver;
